"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let ColumnOperate = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.webSocketService = WebsocketViewService;
  }
  mounted() {
    return __async(this, null, function* () {
      this.webSocketService._ipcEvent.on(
        "event:virtualbrowser.launcher.restart",
        (data) => __async(this, null, function* () {
          if (data.value.new_shop_id === this._column.id) {
            this._column.runtime.status = "loading";
          }
        })
      );
    });
  }
  checkVersion() {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        if (_version === "6.8.2.7") {
          let realVersion = version_response.data.os.version.split("(")[0].trim();
          if (realVersion === "0" || realVersion === "7") {
            let response = yield API.get(`api://base.auth/api/v9/shop/${this._column.shopOldId}/browser_core`);
            if (response.data.code === "chrome" && response.data.version === "122") {
              try {
                try {
                  yield API.get(`api://base.local/storages/session/checkOpenWin7`);
                } catch (error) {
                  yield UiConfirm.warnconfirm(`${this.$t("main.win7_tips_message")}`, this.$t("main.win7_tips_title"), {
                    confirmButtonText: this.$t("main.win7_tips_confirm"),
                    customClass: "new-confirm-box",
                    showClose: false,
                    cancelButtonText: this.$t("headertoolbar.cancel")
                  });
                }
                yield API.put(`api://base.local/storages/session/checkOpenWin7`, {
                  "message": "no.show.win7",
                  "model": "no.show.win7"
                });
                try {
                  yield API.post(`api://base.auth/api/v9/shop/${this._column.shopOldId}/browser_core_auto_downgrade`);
                } catch (error) {
                  return false;
                }
                return false;
              } catch (error) {
                return true;
              }
            }
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    });
  }
  // @Debounce(800)
  launcher() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f;
      try {
        if (((_a = this._column.vd) == null ? void 0 : _a.marks) && ((_b = this._column.vd) == null ? void 0 : _b.marks.is("FLOW_OVER_RANGE"))) {
          try {
            yield UiConfirm.warnconfirm(this.$t("over_flow_dialog.tips"), this.$t("over_flow_dialog.title"), {
              confirmButtonText: this.$t("over_flow_dialog.confirm"),
              showClose: false,
              customClass: "new-confirm-box"
            });
          } catch (error) {
            if (error === "cancel") {
              return;
            }
          }
        }
        const flag = yield this.checkVersion();
        if (flag === true) {
          return;
        }
        this._column.runtime.status = "loading";
        try {
          yield API.get(
            `api://base.local/storages/preference/mainExtensionVersion`
          );
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.launcher_new",
            value: {
              shop_id: this._column.shopOldId,
              vd_id: (_c = this._column.vd) == null ? void 0 : _c.oldId,
              new_vd: (_d = this._column.vd) == null ? void 0 : _d.id,
              new_shop_id: this._column.id
            }
          });
        } catch (error) {
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.launcher",
            value: {
              shop_id: this._column.shopOldId,
              vd_id: (_e = this._column.vd) == null ? void 0 : _e.oldId,
              new_vd: (_f = this._column.vd) == null ? void 0 : _f.id,
              new_shop_id: this._column.id
            }
          });
        }
      } catch (error) {
      }
    });
  }
  closeShop() {
    return __async(this, null, function* () {
      try {
        yield API.delete(`api://base.local/v2/dynamic-browsers/${this._column.shopOldId}`);
        this._column.runtime.status = "ready";
      } catch (error) {
        this._column.runtime.status = "ready";
      }
    });
  }
  toBindVD() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
      }
    });
  }
  toRenew() {
    return __async(this, null, function* () {
      var _a, _b;
      if (!((_a = this.$session) == null ? void 0 : _a.permissions.is("VD_RENEW"))) {
        this.$message.error(this.$i18n.t("main.not_have_renew_permission"));
        return;
      }
      let response = yield API.get(
        `api://base.auth.pro/v1/virtual-desktops/${(_b = this._column.vd) == null ? void 0 : _b.id}`
      );
      this.$router.push({
        name: "payment",
        query: {
          style: "renew"
        },
        params: {
          item: JSON.stringify(response.data)
        }
      });
    });
  }
  toBuy() {
    return __async(this, null, function* () {
      let shop_id = this._column.shopOldId;
      let flag = "false";
      if (this._column.marks.is("DELETE")) {
        flag = "true";
      }
      this.$router.push({
        name: "payment",
        query: { style: "create" },
        params: {
          shop_id,
          is_delete: flag
        }
      });
    });
  }
  handleCommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "shop-detail":
          this.$emit("shopDetail", this._column);
          break;
        case "edit-shop":
          this.$emit("editShop", this._column);
          break;
        case "bind-ip":
          this.$emit("bindIP", this._column);
          break;
        case "choose-admin":
          this.$emit("chooseAdmin", this._column);
          break;
        case "delete-cache":
          this.$emit("deleteCache", this._column);
          break;
        case "add-additional-access":
          this.$emit("additionalAccess", this._column);
          break;
        case "stick-to-top":
          this.$emit("stickToTop", this._column);
          break;
        case "unstick-to-top":
          this.$emit("unstickToTop", this._column);
          break;
        case "edit-group":
          this.$emit("editGroup", this._column);
          break;
        case "delete-shop":
          this.$emit("deleteShop", this._column);
          break;
        case "real-delete-shop":
          this.$emit("realDeleteShop", this._column);
          break;
        case "change-code":
          this.$emit("changeCode", this._column);
          break;
        case "add-video":
          this.$emit("addVideo", this._column);
          break;
        case "close-video":
          this.$emit("closeVideo", this._column);
          break;
        case "import-cookies":
          this.$emit("importCookies", this._column);
          break;
        case "edit-remark":
          this.$emit("editRemark", this._column);
          break;
        case "bind-ip-delete":
          this.$emit("bindIPDelete", this._column);
          break;
        case "cookie-editor":
          this.$emit("cookieEditor", this._column);
          break;
        case "privacy-mode":
          this.$emit("privacyMode", this._column);
          break;
      }
    });
  }
};
__decorateClass([
  PropSync("column")
], ColumnOperate.prototype, "_column", 2);
ColumnOperate = __decorateClass([
  Component({
    components: {
      ItemShop
    }
  })
], ColumnOperate);
export {
  ColumnOperate as default
};
